import { IMappedApiCollection } from "../models/api/i-mapped-api-collection";

export abstract class Adapter<W, D> {
  abstract toView(item: any, secondParam?: any): W;

  toDetailView?(item: any, secondParam?: any): W;
  toDomain?(item: any, secondParam?: any): D;
  mapCollection(response?: any): IMappedApiCollection<W> {
    let count: number =
      response && response?.paginationInfo
        ? response.paginationInfo.totalElements
        : 0;
    let items: W[] = response && response.data ? response.data : response || [];
    return {
      count: count,
      items: items.map((item) => this.toView(item)),
    };
  }
}

export interface PaginationInfo {

  "page": number,
  "itemsPerPage": number,
  "totalElements": number,
  "totalPages": number,
  "isLastPage": boolean
}